module.exports = __webpack_public_path__ + "static/media/WinterborneHome2BookCover.1a77897f.jpg";